import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader, GlassCard, EmptyState } from "@/components/erp";
import { KalipKartlari } from "@/components/kalip/KalipKartlari";
import { Kazanlar, DonguProfilleri } from "@/components/kalip/KazanProfil";
import { Turetimler } from "@/components/kalip/Turetimler";
import { TerminHesap } from "@/components/kalip/TerminHesap";
import { DolulukTakvimi } from "@/components/kalip/DolulukTakvimi";
import { sayi } from "@/components/kalip/Tablo";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/perms";
import api from "@/lib/api";

const Baglantilar = ({ urunler }) => {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [yalniz, setYalniz] = useState(true);
  useEffect(() => { api.get("/kapasite/urunler").then((r) => setList(r.data)); }, []);
  if (!list) return null;
  const g = list.filter((u) => (!yalniz || !u.kapasite.eski) && (!q || `${u.kod} ${u.ad}`.toLowerCase().includes(q.toLowerCase())));
  return (
    <div className="space-y-4" data-testid="kapasite-baglantilar">
      <TerminHesap urunler={urunler} />
      <div className="flex flex-wrap items-center gap-4">
        <Input data-testid="kapasite-ara" className="bg-white/5 max-w-xs" placeholder="Ürün ara" value={q} onChange={(e) => setQ(e.target.value)} />
        <label className="flex items-center gap-2 text-sm"><Switch data-testid="kapasite-yalniz" checked={yalniz} onCheckedChange={setYalniz} />Yalnız kalıp kartına bağlı ürünler</label>
        <span className="text-xs text-muted-foreground">{g.length} ürün{g.length > 200 ? " (ilk 200 gösteriliyor)" : ""}</span>
      </div>
      <p className="text-xs text-muted-foreground">Kalıp bağlamak için ürün kartındaki <b>Kalıp & Kapasite</b> sekmesini kullanın. Ürüne tıklayarak açabilirsiniz.</p>
      <GlassCard className="overflow-x-auto erp-scroll">
        {g.length === 0 ? <EmptyState text="Kalıba bağlı ürün yok." testid="kapasite-bos" /> : (
          <table className="w-full text-sm" data-testid="kapasite-tablo">
            <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground border-b border-white/5">
              <th className="p-3">Ürün</th><th className="p-3 text-right">Kalıp</th><th className="p-3 text-right">Döngü</th><th className="p-3 text-right">Çıktı × Çarpan</th><th className="p-3">Kazan</th><th className="p-3 text-right">Günlük kapasite</th>
            </tr></thead>
            <tbody>{g.slice(0, 200).map((u) => { const k = u.kapasite; return (
              <tr key={u.id} className="border-b border-white/5" data-testid={`kapasite-satir-${u.kod}`}>
                <td className="p-3"><Link to={`/urunler/${u.id}?sekme=kalip`} className="hover:underline"><span className="font-mono text-xs">{u.kod}</span> <span className="text-muted-foreground">{u.ad}</span></Link>{k.eski && <span className="ml-2 text-[10px] text-amber-300">özellik kartından</span>}</td>
                <td className="p-3 text-right font-mono">{k.eski ? sayi(k.kullanilabilir_kalip) : `${k.kullanilabilir_kalip}/${k.toplam_kalip}`}</td>
                <td className="p-3 text-right font-mono">{sayi(k.gunluk_dongu)}</td>
                <td className="p-3 text-right font-mono">{sayi(k.cevrim_cikti)} × {sayi(k.nihai_carpan)}</td>
                <td className="p-3">{k.kazan_ad || "—"}</td>
                <td className="p-3 text-right font-semibold" data-testid={`kapasite-gunluk-${u.kod}`}>{sayi(k.gunluk_kapasite)}</td>
              </tr>); })}</tbody>
          </table>
        )}
      </GlassCard>
    </div>
  );
};

export default function KalipTermin() {
  const { user } = useAuth();
  const yaz = can(user, "uretim:plan");
  const [urunler, setUrunler] = useState([]);
  const [qs, setQs] = useSearchParams();
  const sekme = qs.get("sekme") || "kaliplar";
  useEffect(() => { api.get("/urunler").then((r) => setUrunler(r.data.filter((u) => u.aktif !== false && ["mamul", "yari_mamul"].includes(u.kategori_tipi)))); }, []);
  const sekmeler = [["kaliplar", "Kalıp Kartları"], ["kazanlar", "Kazanlar"], ["profiller", "Döngü Profilleri"], ["urunler", "Ürün Kapasiteleri & Termin"], ["turetim", "Metrelikten Kesim"], ["doluluk", "Doluluk Takvimi"]];
  return (
    <div data-testid="kalip-termin-page">
      <PageHeader title="Kalıp & Kapasite" desc="Günlük kapasite = kullanılabilir kalıp × günlük döngü × çevrim başına çıktı × nihai çarpan. Kazan yalnızca gerçek darboğaz olduğunda ayrıca sınırlar." />
      <Tabs value={sekme} onValueChange={(v) => setQs({ sekme: v }, { replace: true })}>
        <TabsList className="flex-wrap h-auto mb-4">{sekmeler.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`kt-sekme-${k}`}>{l}</TabsTrigger>)}</TabsList>
        <TabsContent value="kaliplar"><KalipKartlari yaz={yaz} /></TabsContent>
        <TabsContent value="kazanlar"><Kazanlar yaz={yaz} /></TabsContent>
        <TabsContent value="profiller"><DonguProfilleri yaz={yaz} /></TabsContent>
        <TabsContent value="urunler"><Baglantilar urunler={urunler} /></TabsContent>
        <TabsContent value="turetim"><Turetimler yaz={yaz} urunler={urunler} /></TabsContent>
        <TabsContent value="doluluk"><DolulukTakvimi /></TabsContent>
      </Tabs>
    </div>
  );
}
